import { IconIdentifier } from './iconIdentifiers';

export const iconMapping: Record<string, IconIdentifier> = {
  '2fa-colored': 'device-phone-mobile',
  'access-time': 'clock',
  'active-directory': 'cloud',
  all_inclusive: 'cloud',
  'attach-money': 'banknotes',
  annotation: 'chat-bubble-bottom-center-text',
  auditing: 'cube-transparent',
  'auto-detection-colored': 'cloud',
  'business-use': 'briefcase',
  clock: 'clock',
  cloud_done: 'cloud',
  'clouds-colored': 'cloud',
  'desktop-computer': 'computer-desktop',
  devices: 'device-phone-mobile',
  'devices-colored': 'computer-desktop',
  'discount-colored': 'academic-cap',
  'end-to-end-encryption-colored': 'lock-closed',
  exposure_plus_1: 'cloud',
  exposure_plus_2: 'device-phone-mobile',
  face: 'face-smile',
  'filename-encryption': 'language',
  'folder-structure': 'folder',
  'free-colored': 'face-smile',
  group: 'user-plus',
  group_add: 'users',
  'headset-mic': 'microphone',
  home: 'home',
  'Icon_Collaboration.svg': 'user-group',
  'Icon_Enterprise-Ready.svg': 'check-badge',
  'office-building': 'building-office',
  'Outlined_Benefit-Icon_Add-Providers-OneDrive.svg': 'cloud',
  'Outlined_Benefit-Icon_Encrypted-Files-Teams.svg': 'lock-closed',
  'Outlined_Benefit-Icon_Encrypted-Messages-Teams.svg': 'chat-bubble-left-right',
  'Outlined_Benefit-Icon_Microsoft-Teams.svg': 'users',
  'Outlined_Benefit-Icon_Encrypt_No-Wifi.svg': 'wifi',
  'Outlined_Benefit-Icon_Encrypted-Sharing-Teams.svg': 'share',
  'Icon_Productivity.svg': 'arrow-trending-up',
  'Icon_Workflow.svg': 'cog',
  library: 'building-library',
  'light-bulb': 'light-bulb',
  'local-encryption-colored': 'key',
  'lock-closed.png': 'lock-closed',
  'key.png': 'key',
  'made-in-germany-colored': 'home',
  mail_outline: 'at-symbol',
  mood: 'face-smile',
  person: 'user',
  person_add: 'user-plus',
  phonelink_ring: 'device-phone-mobile',
  priority_high: 'exclamation-circle',
  restore: 'clock',
  sentiment_satisfied: 'face-smile',
  'server-location-colored': 'circle-stack',
  settings: 'cog',
  'settings-phone': 'phone',
  'share.png': 'share',
  'share-colored': 'users',
  sso: 'share',
  star: 'star',
  'supervisor-account': 'users',
  ticket: 'ticket',
  'trending-up': 'arrow-trending-up',
  'user-group': 'user-group',
  'vpn-key': 'key',
  vpn_key: 'key',
  'web-app': 'computer-desktop',
  whisply: 'cloud-arrow-up',
  'zero-knowledge-colored': 'eye-slash',
  access_time: 'clock',
  fiber_pin: 'map-pin',
  send: 'inbox-arrow-down',
  cloud_off: 'cloud-arrow-down',
  attach_money: 'banknotes',
  done_all: 'check-circle',
  money_off: 'banknotes',
  work: 'briefcase',
  'Microsoft Teams Logo.png': 'microsoft-teams',
};
